import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { environment } from 'src/environments/environment';
import { NeoParametrizacionLineaDTO } from '../Model/neoParametrizacionLineaDTO';
import { catchError } from "rxjs/operators";
import { HandleHttpError } from 'src/app/core/utils/HttpHandleError';

const API_URL = environment.apiLocalUrl + 'neoParametrizacionLinea';
@Injectable({
  providedIn: 'root',
})
export class ParametrizacionLineaService {
  constructor(private _http: HttpClient) {}

  getParametrizacionLinea(): Observable<NeoParametrizacionLineaDTO[]> {
    return this._http.get<NeoParametrizacionLineaDTO[]>(API_URL).pipe(catchError(HandleHttpError));
  }

  getParametrizacionesLineaPorIdCliente(
    idNeoCliente
  ): Observable<NeoParametrizacionLineaDTO[]> {
    return this._http.get<NeoParametrizacionLineaDTO[]>(
      `${API_URL}/neoCliente/${idNeoCliente}`
    ).pipe(catchError(HandleHttpError));
  }

  getParametrizacionLineaPorId(
    idParametrizacionLinea
  ): Observable<NeoParametrizacionLineaDTO> {
    return this._http.get<NeoParametrizacionLineaDTO>(
      `${API_URL}/${idParametrizacionLinea}`
    ).pipe(catchError(HandleHttpError));
  }

  saveParametrizacionLinea(
    parametrizacionLinea: NeoParametrizacionLineaDTO
  ): Observable<NeoParametrizacionLineaDTO> {
    let headers = new HttpHeaders().set('Content-type', 'application/json');

    return this._http.post<NeoParametrizacionLineaDTO>(
      API_URL,
      parametrizacionLinea,
      { headers: headers }
    ).pipe(catchError(HandleHttpError));
  }

  updateParametrizacionLinea(
    parametrizacionLinea: NeoParametrizacionLineaDTO
  ): Observable<NeoParametrizacionLineaDTO> {
    let headers = new HttpHeaders().set('Content-type', 'application/json');

    return this._http.put<NeoParametrizacionLineaDTO>(
      API_URL,
      parametrizacionLinea,
      { headers: headers }
    ).pipe(catchError(HandleHttpError));
  }

  deleteParametrizacionLinea(idParametrizacionLinea): Observable<any> {
    return this._http.delete<any>(`${API_URL}/${idParametrizacionLinea}`).pipe(catchError(HandleHttpError));
  }

  getLineasAliado(estado: any) {
    return this._http.get<any>(`${environment.apiLocalUrl}neoNombreLineasCredito/service/Lineas/estado/${estado}`).pipe(catchError(HandleHttpError));
  }
}
